import questionnaire from './../../../Onboarding/questionnaire.js';

export default questionnaire;
